import Member from '@/views/webpc/MemberManagement/MemberList/Member'

// 定义路由路径数列表
export default [{
  path: '/memberList',
  icon: 'el-icon-user',
  name: '会员列表',
  component: Member
}]



// WEBPACK FOOTER //
// ./src/views/webpc/MemberManagement/MemberList/routers/index.js